import { addresses as ADDRESS } from "../configs/constants";
import { SupportedChainId } from "./chainENV/chains.base";
import { getTokenBySymbol } from "src/configs/Tokens";
import PLP_1 from "src/assets/images/tokens/PLP-β.svg";
// import PLP_2 from "src/assets/images/tokens/PLP-α.svg";

//  PLP 默认查询  数据列表
type ListProps = {
  name: PLP_TYPES;
  icon: any;
  top: string;
  Plp_address: string;
  PlpManager_address: string;
  rewardTracker_address: string;
  isOld?: boolean; // 是否是旧版plp
  vault_address: string;
  positionRouter_address: string;
  orderBook_address: string;
  router_address: string;
  positionManager_address: string;
  isGNS?: boolean; // 是否是gns 模式
  routerSign_address?: string; // 新版签名模式
  vaultUtil_addr?: string; // 新版查询
  fee_router?: string;
};

type LpListProps = {
  name: string;
  stakeToken: string;
  isLp: boolean;
  pool: string;
  imgUrl: any;
  stablecoin: boolean;
  rewardToken: string;
  token0?: {
    address: string;
    decimals: number;
  };
  token1?: {
    address: string;
    decimals: number;
  };
};

export enum PLP_TYPES {
  PLP_1 = "PLP-β",
  PLP_2 = "PLP-α",
}
export const PLP_LIST: { [key: number]: ListProps[] } = {
  [SupportedChainId.ZKMAINNET]: [
    {
      name: PLP_TYPES.PLP_1,
      icon: PLP_1,
      top: "Top 5 ETF",
      Plp_address: ADDRESS[SupportedChainId.ZKMAINNET].PLP_β,
      vault_address: ADDRESS[SupportedChainId.ZKMAINNET].Vault_PLP_β,
      vaultUtil_addr: ADDRESS[SupportedChainId.ZKMAINNET].VaultUtils_PLP_β,
      PlpManager_address: ADDRESS[SupportedChainId.ZKMAINNET].PlpManager_PLP_β,
      rewardTracker_address:
        ADDRESS[SupportedChainId.ZKMAINNET].RewardPool_PLP_β,
      positionRouter_address:
        ADDRESS[SupportedChainId.ZKMAINNET].PositionRouter_PLP_β,
      orderBook_address: ADDRESS[SupportedChainId.ZKMAINNET].OrderBook_PLP_β,
      router_address: ADDRESS[SupportedChainId.ZKMAINNET].Router_PLP_β,
      positionManager_address:
        ADDRESS[SupportedChainId.ZKMAINNET].PositionManager_PLP_β,
      routerSign_address: ADDRESS[SupportedChainId.ZKMAINNET].RouterSign_PLP_β,
      fee_router: ADDRESS[SupportedChainId.ZKMAINNET].FeeRouter_PLP_β,
    },
  ],
  [SupportedChainId.ZKTEST]: [
    {
      name: PLP_TYPES.PLP_1,
      icon: PLP_1,
      top: "Top 5 ETF",
      Plp_address: ADDRESS[SupportedChainId.ZKTEST].PLP_β,
      vault_address: ADDRESS[SupportedChainId.ZKTEST].Vault_PLP_β,
      vaultUtil_addr: ADDRESS[SupportedChainId.ZKTEST].VaultUtils_PLP_β,
      PlpManager_address: ADDRESS[SupportedChainId.ZKTEST].PlpManager_PLP_β,
      rewardTracker_address: ADDRESS[SupportedChainId.ZKTEST].RewardPool_PLP_β,
      positionRouter_address:
        ADDRESS[SupportedChainId.ZKTEST].PositionRouter_PLP_β,
      orderBook_address: ADDRESS[SupportedChainId.ZKTEST].OrderBook_PLP_β,
      router_address: ADDRESS[SupportedChainId.ZKTEST].Router_PLP_β,
      positionManager_address:
        ADDRESS[SupportedChainId.ZKTEST].PositionManager_PLP_β,
      routerSign_address: ADDRESS[SupportedChainId.ZKTEST].RouterSign_PLP_β,
      fee_router: ADDRESS[SupportedChainId.ZKTEST].FeeRouter_PLP_β,
    },
  ],
  [SupportedChainId.MANTLE_TEST]: [
    {
      name: PLP_TYPES.PLP_1,
      icon: PLP_1,
      top: "Top 5 ETF",
      Plp_address: ADDRESS[SupportedChainId.MANTLE_TEST].PLP_β,
      vault_address: ADDRESS[SupportedChainId.MANTLE_TEST].Vault_PLP_β,
      vaultUtil_addr: ADDRESS[SupportedChainId.MANTLE_TEST].VaultUtils_PLP_β,
      PlpManager_address:
        ADDRESS[SupportedChainId.MANTLE_TEST].PlpManager_PLP_β,
      rewardTracker_address:
        ADDRESS[SupportedChainId.MANTLE_TEST].RewardTracker_PLP_β,
      positionRouter_address:
        ADDRESS[SupportedChainId.MANTLE_TEST].PositionRouter_PLP_β,
      orderBook_address: ADDRESS[SupportedChainId.MANTLE_TEST].OrderBook_PLP_β,
      router_address: ADDRESS[SupportedChainId.MANTLE_TEST].Router_PLP_β,
      positionManager_address:
        ADDRESS[SupportedChainId.MANTLE_TEST].PositionManager_PLP_β,
      routerSign_address:
        ADDRESS[SupportedChainId.MANTLE_TEST].RouterSign_PLP_β,
      fee_router: ADDRESS[SupportedChainId.MANTLE_TEST].FeeRouter_PLP_β,
    },
  ],
  [SupportedChainId.MANTLE]: [
    {
      name: PLP_TYPES.PLP_1,
      icon: PLP_1,
      top: "Top 5 ETF",
      Plp_address: ADDRESS[SupportedChainId.MANTLE].PLP_β,
      vault_address: ADDRESS[SupportedChainId.MANTLE].Vault_PLP_β,
      vaultUtil_addr: ADDRESS[SupportedChainId.MANTLE].VaultUtils_PLP_β,
      PlpManager_address: ADDRESS[SupportedChainId.MANTLE].PlpManager_PLP_β,
      rewardTracker_address: ADDRESS[SupportedChainId.MANTLE].RewardPool_PLP_β,
      positionRouter_address:
        ADDRESS[SupportedChainId.MANTLE].PositionRouter_PLP_β,
      orderBook_address: ADDRESS[SupportedChainId.MANTLE].OrderBook_PLP_β,
      router_address: ADDRESS[SupportedChainId.MANTLE].Router_PLP_β,
      positionManager_address:
        ADDRESS[SupportedChainId.MANTLE].PlpManager_PLP_β,
      routerSign_address: ADDRESS[SupportedChainId.MANTLE].RouterSign_PLP_β,
      fee_router: ADDRESS[SupportedChainId.MANTLE].FeeRouter_PLP_β,
    },
    {
      name: PLP_TYPES.PLP_2,
      icon: PLP_1,
      top: "Top 5 ETF",
      Plp_address: ADDRESS[SupportedChainId.MANTLE].PLP_α,
      vault_address: ADDRESS[SupportedChainId.MANTLE].Vault_PLP_α,
      vaultUtil_addr: ADDRESS[SupportedChainId.MANTLE].VaultUtils_PLP_α,
      PlpManager_address: ADDRESS[SupportedChainId.MANTLE].PlpManager_PLP_α,
      rewardTracker_address: ADDRESS[SupportedChainId.MANTLE].RewardPool_PLP_α,
      positionRouter_address:
        ADDRESS[SupportedChainId.MANTLE].PositionRouter_PLP_α,
      orderBook_address: ADDRESS[SupportedChainId.MANTLE].OrderBook_PLP_α,
      router_address: ADDRESS[SupportedChainId.MANTLE].Router_PLP_α,
      positionManager_address:
        ADDRESS[SupportedChainId.MANTLE].PositionManager_PLP_α,
      routerSign_address: ADDRESS[SupportedChainId.MANTLE].RouterSign_PLP_α,
      isGNS: true,
      fee_router: ADDRESS[SupportedChainId.MANTLE].FeeRouter_PLP_α,
    },
  ],
  [SupportedChainId.ARBITRUM]: [
    {
      name: PLP_TYPES.PLP_1,
      icon: PLP_1,
      top: "Top 5 ETF",
      Plp_address: ADDRESS[SupportedChainId.ARBITRUM].PLP_β,
      vault_address: ADDRESS[SupportedChainId.ARBITRUM].Vault_PLP_β,
      vaultUtil_addr: ADDRESS[SupportedChainId.ARBITRUM].VaultUtils_PLP_β,
      PlpManager_address: ADDRESS[SupportedChainId.ARBITRUM].PlpManager_PLP_β,
      rewardTracker_address:
        ADDRESS[SupportedChainId.ARBITRUM].RewardPool_PLP_β,
      positionRouter_address:
        ADDRESS[SupportedChainId.ARBITRUM].PositionRouter_PLP_β,
      orderBook_address: ADDRESS[SupportedChainId.ARBITRUM].OrderBook_PLP_β,
      router_address: ADDRESS[SupportedChainId.ARBITRUM].Router_PLP_β,
      positionManager_address:
        ADDRESS[SupportedChainId.ARBITRUM].PlpManager_PLP_β,
      routerSign_address: ADDRESS[SupportedChainId.ARBITRUM].RouterSign_PLP_β,
      fee_router: ADDRESS[SupportedChainId.ARBITRUM].FeeRouter_PLP_β,
    },
  ],
  [SupportedChainId.ARB_TEST]: [
    {
      name: PLP_TYPES.PLP_1,
      icon: PLP_1,
      top: "Top 5 ETF",
      Plp_address: ADDRESS[SupportedChainId.ARB_TEST].PLP_β,
      vault_address: ADDRESS[SupportedChainId.ARB_TEST].Vault_PLP_β,
      vaultUtil_addr: ADDRESS[SupportedChainId.ARB_TEST].VaultUtils_PLP_β,
      PlpManager_address: ADDRESS[SupportedChainId.ARB_TEST].PlpManager_PLP_β,
      rewardTracker_address:
        ADDRESS[SupportedChainId.ARB_TEST].RewardPool_PLP_β,
      positionRouter_address:
        ADDRESS[SupportedChainId.ARB_TEST].PositionRouter_PLP_β,
      orderBook_address: ADDRESS[SupportedChainId.ARB_TEST].OrderBook_PLP_β,
      router_address: ADDRESS[SupportedChainId.ARB_TEST].Router_PLP_β,
      positionManager_address:
        ADDRESS[SupportedChainId.ARB_TEST].PlpManager_PLP_β,
      routerSign_address: ADDRESS[SupportedChainId.ARB_TEST].RouterSign_PLP_β,
      fee_router: ADDRESS[SupportedChainId.ARB_TEST].FeeRouter_PLP_β,
    },
    {
      name: PLP_TYPES.PLP_2,
      icon: PLP_1,
      top: "Top 5 ETF",
      Plp_address: ADDRESS[SupportedChainId.ARB_TEST].PLP_α,
      vault_address: ADDRESS[SupportedChainId.ARB_TEST].Vault_PLP_α,
      vaultUtil_addr: ADDRESS[SupportedChainId.ARB_TEST].VaultUtils_PLP_α,
      PlpManager_address: ADDRESS[SupportedChainId.ARB_TEST].PlpManager_PLP_α,
      rewardTracker_address:
        ADDRESS[SupportedChainId.ARB_TEST].RewardPool_PLP_α,
      positionRouter_address:
        ADDRESS[SupportedChainId.ARB_TEST].PositionRouter_PLP_α,
      orderBook_address: ADDRESS[SupportedChainId.ARB_TEST].OrderBook_PLP_α,
      router_address: ADDRESS[SupportedChainId.ARB_TEST].Router_PLP_α,
      positionManager_address:
        ADDRESS[SupportedChainId.ARB_TEST].PositionManager_PLP_α,
      routerSign_address: ADDRESS[SupportedChainId.ARB_TEST].RouterSign_PLP_α,
      isGNS: true,
      fee_router: ADDRESS[SupportedChainId.ARB_TEST].FeeRouter_PLP_α,
    },
  ],
};

export const STAKE_LP_LIST: { [key: number]: LpListProps[] } = {
  [SupportedChainId.ARB_TEST]: [],
};

export const PAIR_DETAILS: {
  [key: number]: {
    [lp: string]:
      | {
          token0: {
            address: string;
            decimals: number;
            name: string;
          };
          token1: {
            address: string;
            decimals: number;
            name: string;
          };
        }
      | undefined;
  };
} = {
  [SupportedChainId.ZKTEST]: {
    "": {
      token0: {
        address: "",
        decimals: 18,
        name: "weth",
      },
      token1: {
        address: "",
        decimals: 18,
        name: "piko",
      },
    },
  },
};

export function getNormalizedTokenSymbol(tokenSymbol) {
  if (["WBTC", "WETH", "WBNB"].includes(tokenSymbol)) {
    return tokenSymbol.substr(1);
  } else if (tokenSymbol === "BTC.b") {
    return "BTC";
  }
  return tokenSymbol;
}

const AVAILABLE_CHART_TOKENS = {
  [SupportedChainId.ZKTEST]: [
    "ETH",
    "BTC",
    "BNB",
    "DOGE",
    "ARB",
    "LINK",
    "MATIC",
    "DOT",
  ],
  [SupportedChainId.ZKMAINNET]: ["ETH", "BTC", "USDC"],
  [SupportedChainId.MANTLE_TEST]: [
    "ETH",
    "BTC",
    "BNB",
    "DOGE",
    "ARB",
    "LINK",
    "MATIC",
    "DOT",
  ],
  [SupportedChainId.MANTLE]: [
    "ETH",
    "BTC",
    "MNT",
    "ARB",
    "OP",
    "BNB",
    "SOL",
    "SUI",
    "DOGE",
    "MATIC",
    "PEPE",
  ],
  [SupportedChainId.ARBITRUM]: [
    "ETH",
    "BTC",
    "USDC",
    "ARB",
    "OP",
    "BNB",
    "SOL",
    "SUI",
    "MATIC",
    "PEPE",
    "DOGE",
  ],
  [SupportedChainId.ARB_TEST]: [
    "ETH",
    "BTC",
    "USDC",
    "ARB",
    "OP",
    "BNB",
    "SOL",
    "SUI",
    "MATIC",
    "PEPE",
    "DOGE",
  ],
};

export function isChartAvailabeForToken(chainId: number, tokenSymbol: string) {
  const token = getTokenBySymbol(chainId, tokenSymbol);
  if (!token) return false;

  return (
    (token.isStable ||
      AVAILABLE_CHART_TOKENS[chainId]?.includes(
        getNormalizedTokenSymbol(tokenSymbol)
      )) ??
    false
  );
}
